'use strict';

var cov_17kwlq8qme = function () {
  var path = '/Users/jvvbsocianova/Projects/socianova/marty/src/app/main/main.js',
      hash = '5f4a0ab639f1a306c7f13708e0eb5ce019784423',
      global = new Function('return this')(),
      gcv = '__coverage__',
      coverageData = {
    path: '/Users/jvvbsocianova/Projects/socianova/marty/src/app/main/main.js',
    statementMap: {
      '0': {
        start: {
          line: 3,
          column: 4
        },
        end: {
          line: 3,
          column: 25
        }
      },
      '1': {
        start: {
          line: 4,
          column: 4
        },
        end: {
          line: 4,
          column: 21
        }
      },
      '2': {
        start: {
          line: 12,
          column: 4
        },
        end: {
          line: 12,
          column: 35
        }
      },
      '3': {
        start: {
          line: 14,
          column: 4
        },
        end: {
          line: 14,
          column: 32
        }
      },
      '4': {
        start: {
          line: 18,
          column: 0
        },
        end: {
          line: 23,
          column: 5
        }
      }
    },
    fnMap: {
      '0': {
        name: '(anonymous_0)',
        decl: {
          start: {
            line: 2,
            column: 2
          },
          end: {
            line: 2,
            column: 3
          }
        },
        loc: {
          start: {
            line: 2,
            column: 28
          },
          end: {
            line: 5,
            column: 3
          }
        }
      },
      '1': {
        name: '(anonymous_1)',
        decl: {
          start: {
            line: 11,
            column: 2
          },
          end: {
            line: 11,
            column: 3
          }
        },
        loc: {
          start: {
            line: 11,
            column: 16
          },
          end: {
            line: 15,
            column: 3
          }
        }
      }
    },
    branchMap: {},
    s: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0
    },
    f: {
      '0': 0,
      '1': 0
    },
    b: {},
    _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var AppComponent = function () {
  function AppComponent($log, $state) {
    _classCallCheck(this, AppComponent);

    ++cov_17kwlq8qme.f[0];
    ++cov_17kwlq8qme.s[0];

    this.$state = $state;
    ++cov_17kwlq8qme.s[1];
    this.$log = $log;
  }

  /**
   * La connexion a réussie.
   */

  _createClass(AppComponent, [{
    key: 'authSuccess',
    value: function authSuccess() {
      ++cov_17kwlq8qme.f[1];
      ++cov_17kwlq8qme.s[2];

      this.$log.info('Auth Success');

      ++cov_17kwlq8qme.s[3];
      this.$state.go('dashboard');
    }
  }]);

  return AppComponent;
}();

++cov_17kwlq8qme.s[4];


angular.module('app').component('main', {
  templateUrl: 'app/main/main.html',
  controller: AppComponent
});